import IconNotAssigned from 'assets/images/not-assigned.png';
import IconTask from 'assets/images/clipboard.png';

export enum FILTER_STATUS_SUB_HK_VALUE {
  ALL = 'all',
  AVAILABLE = 'available',
  ARR = 'ARR',
  FS = 'FS',
  DEP = 'DEP',
  DIRTY = 'dirty',
  LOCKED = 'locked',
  NOT_ASSIGNED = 'not_assigned',
  TASK = 'TASK',
  OD = 'OD'
}

export const getFilterStatusSubHk = (t: (key: string) => string) => [
  {
    label: t('hk.status.all'),
    value: FILTER_STATUS_SUB_HK_VALUE.ALL,
    color: '#EFAC00',
    bgColor: '#FFF2CF'
  },
  {
    label: t('hk.status.available'),
    value: FILTER_STATUS_SUB_HK_VALUE.AVAILABLE,
    color: '#42A046',
    bgColor: '#E4FBE5'
  },
  {
    label: t('hk.status.dirty'),
    value: FILTER_STATUS_SUB_HK_VALUE.DIRTY,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  },
  {
    label: <img src={IconNotAssigned} alt="not-assigned" width={24} height={24} />,
    value: FILTER_STATUS_SUB_HK_VALUE.NOT_ASSIGNED,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  },
  {
    label: t('hk.status.arr'),
    value: FILTER_STATUS_SUB_HK_VALUE.ARR,
    color: '#0782EB',
    bgColor: '#EBF6FF'
  },
  {
    label: t('hk.status.dep'),
    value: FILTER_STATUS_SUB_HK_VALUE.DEP,
    color: '#9513A8',
    bgColor: '#FDECFF'
  },
  {
    label: t('hk.status.fs'),
    value: FILTER_STATUS_SUB_HK_VALUE.FS,
    color: '#CE370F',
    bgColor: '#FFE7E0'
  },
  {
    label: <img src={IconTask} alt="task" width={22} height={22} style={{ marginRight: 4 }} />,
    value: FILTER_STATUS_SUB_HK_VALUE.TASK,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  },
  {
    label: t('hk.status.od'),
    value: FILTER_STATUS_SUB_HK_VALUE.OD,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  }
];

export const getFilterStatusHk = (t: (key: string) => string) => [
  {
    label: t('hk.status.all'),
    value: FILTER_STATUS_SUB_HK_VALUE.ALL,
    color: '#EFAC00',
    bgColor: '#FFF2CF'
  },
  {
    label: t('hk.status.available'),
    value: FILTER_STATUS_SUB_HK_VALUE.AVAILABLE,
    color: '#42A046',
    bgColor: '#E4FBE5'
  },
  {
    label: t('hk.status.dirty'),
    value: FILTER_STATUS_SUB_HK_VALUE.DIRTY,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  },
  {
    label: t('hk.status.arr'),
    value: FILTER_STATUS_SUB_HK_VALUE.ARR,
    color: '#0782EB',
    bgColor: '#EBF6FF'
  },
  {
    label: t('hk.status.dep'),
    value: FILTER_STATUS_SUB_HK_VALUE.DEP,
    color: '#9513A8',
    bgColor: '#FDECFF'
  },
  {
    label: t('hk.status.fs'),
    value: FILTER_STATUS_SUB_HK_VALUE.FS,
    color: '#CE370F',
    bgColor: '#FFE7E0'
  },
  {
    label: t('hk.status.od'),
    value: FILTER_STATUS_SUB_HK_VALUE.OD,
    color: '#100F0F',
    bgColor: '#E2E0E0'
  }
];
